import {
  axisLablesFontSizeSet,
  chartChartConfig,
  chartCommonConfig,
  chartLineColorsConfig,
  chartTitleConfig,
  chartYaxisConfig
} from '../../../config/chartCommon';
import eventFire from '../../../utilities/eventFire-inside-highcharts';
import getTotalEnergyUseBarTooltop from '../utilities/main.total.energy.use.bar.tooltip';
import { barColorCode } from '../incomersAndGeneratorsConfig/common';
function totalEnergyUseChartDataConfig(
  chartApiData,
  graphFilter,
  graphName,
  drillDownLevel,
  userAccessibility,
  setDrilldownDate,
  daySummaryDrilldownDate,
  daySummaryDrilldownEnabled,
  graphTooltip,
  chartUnit,
  chartSlugInfo,
  graphDetails
) {
  // console.log("daySummaryDrilldownEnabled", daySummaryDrilldownDate);

  const isMultipleSeries =
    Array.isArray(chartApiData) && chartApiData.length > 0 && chartApiData[0]?.data;
  const findDuration = (data) => {
    const durationTime =
      data?.options?.hour_range || data?.options?.week_range || data?.options?.month_range || '';
    return durationTime !== '' ? `,&nbsp${durationTime}` : '';
  };
  const findCarbon = (data, index) => {
    const carbon = data[index]?.point?.co2_emission || '';
    return carbon !== '' ? `, <b>${carbon?.toFixed(2)}</b> kg CO₂` : '';
  };
  const unitName = isMultipleSeries?.unit_name;
  console.log('unitName', unitName);

  const categories =
    isMultipleSeries && chartApiData[0]?.data ? chartApiData[0].data.map((d) => d.name) : null;
  const isWaterOrAirChart =
    graphDetails?.layer_type === 'water_flow' ||
    graphDetails?.graphInfo?.layer_type === 'water_flow' ||
    graphDetails?.layer_type === 'air_flow' ||
    graphDetails?.graphInfo?.layer_type === 'air_flow';

  const getStepCount = () => {
    if (!isMultipleSeries || isWaterOrAirChart) {
      return graphFilter.filterMain == '1day' || daySummaryDrilldownDate ? 2 : 0;
    }

    return graphFilter.filterMain === '1day' ||
      graphFilter.filterMain === '1month' ||
      daySummaryDrilldownDate
      ? 3
      : 1;
  };

  const TooltipNameFormatter = (props) => {
    if (props?.options?.hour_range) {
      let name = props.name;
      let remove_after = name.indexOf(',');
      let date_alone = name.substring(0, remove_after);
      return date_alone;
    } else {
      return props?.name;
    }
  };
  const ColorIndicator = (name) => {
    return barColorCode
      ?.filter((colors) => {
        if (colors?.name === name) return colors?.color;
      })
      ?.map((colors) => colors.color)?.[0];
  };

  // Format series same as Incomers config
  const seriesData = isMultipleSeries
    ? chartApiData.map((series) => ({
        name: series.equipment_name || series.name,
        data: series.data || [],
        color: series.color || null,
        total: series.total,
        type: 'column',
        custom: {
          unit: series.unit_name || chartUnit
        }
      }))
    : [
        {
          data: chartApiData || [],
          type: 'column',
          color: '#71B2FF'
        }
      ];

  const config = {
    ...chartTitleConfig({
      graphTitle: graphName,
      userAccessibility,
      graphTooltip
    }),

    ...chartCommonConfig,
    ...chartLineColorsConfig,

    chart: {
      ...chartChartConfig({ userAccessibility }),
      spacingTop: 10,
      spacingBottom: 30,
      className: 'totalenergyuse-main',
      zoomType: null,
      panning: false,
      pinchType: null
    },

    series: seriesData,
    exporting: {
      chartOptions: {
        chart: {
          spacingBottom: isMultipleSeries ? 25 : 30
        },
        // chartOptions: {
        title: {
          text: `${graphName} - ${
            graphDetails?.process
              ? graphDetails.process
              : graphDetails?.drilldownlevel == 'Home' && 'Plant'
          }`

          // text: `${graphName} - ${graphDetails.process}`
        },
        // }

        subtitle: {
          text: ''
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              format: '{point.y:,.0f}',
              style: {
                fontSize: graphFilter.filterMain != '1week' ? '9px' : '11px'
              },
              allowOverlap: true,
              crop: false,
              overflow: 'allow'
            }
          }
        }
      }
    },

    legend: {
      enabled: false,
      align: 'center',
      verticalAlign: 'bottom',
      y: 30,
      itemStyle: {
        fontWeight: 'lighter',
        fontSize: axisLablesFontSizeSet(userAccessibility)
      },

      // same legend formatter as first config
      labelFormatter: function () {
        if (this?.userOptions?.total !== null) {
          return (
            this.name +
            (this?.userOptions?.total !== undefined
              ? `<b>: &nbsp${this.userOptions.total.toFixed(0)} kWh</b>`
              : '')
          );
        }
        return this.name;
      }
    },

    plotOptions: {
      column: {
        minPointLength: 3,
        grouping: isMultipleSeries,
        cursor: 'pointer',
        pointPadding: isMultipleSeries ? -0.3 : 0.2,
        groupPadding: isMultipleSeries ? 0.3 : 0.2,

        point: {
          events: {
            click: function (data) {
              if (daySummaryDrilldownEnabled && data.point.summary_date) {
                setDrilldownDate(data.point.summary_date);
              }
            }
          }
        }
      }
    },

    xAxis: {
      reversedStacks: false,
      lineColor: '#cccccc',
      categories: isWaterOrAirChart ? null : categories,
      labels: {
        autoRotation: undefined,

        formatter: function () {
          if (this.chart.options.chart.className === 'totalenergyuse-main') {
            const dataPoint = isMultipleSeries
              ? chartApiData[0]?.data[this.value]
              : chartApiData?.[this.value];

            return dataPoint?.name || this.value;
          }
        },

        style: {
          fontSize: axisLablesFontSizeSet(userAccessibility),
          cursor:
            (graphFilter.filterMain === '1week' || graphFilter.filterMain === '1month') &&
            daySummaryDrilldownEnabled &&
            !daySummaryDrilldownDate
              ? 'pointer'
              : 'initial'
        },

        padding: 20,
        step: getStepCount(),
        events: {
          click: function () {
            const el = document.querySelectorAll('.totalenergyuse-main .highcharts-point')[
              this.pos
            ];

            if (
              (graphFilter.filterMain === '1week' || graphFilter.filterMain === '1month') &&
              daySummaryDrilldownEnabled
            ) {
              eventFire(el, 'click');
            }
          }
        }
      },

      tickLength: 0,
      tickPixelInterval: 70
    },

    yAxis: [
      {
        opposite: false
      }
    ],

    ...chartYaxisConfig({ userAccessibility }),

    // shared tooltip like Incomers config
    tooltip: {
      useHTML: true,
      shared: isMultipleSeries,
      style: {
        lineHeight: '20px',
        height: '100%',
        whiteSpace: 'nowrap',
        width: '250px',
        minWidth: '250px',
        padding: '20px'
      },
      formatter: isMultipleSeries
        ? function () {
            let is_incomplete_flag = false;
            let tooltip =
              '<div class="txt-10">' +
              TooltipNameFormatter(this.point) +
              findDuration(this.point) +
              '</div>';
            this.points.forEach((point, index) => {
              if (this.point.incomplete_flag === true) {
                is_incomplete_flag = true;
              }
              // m³ value
                tooltip +=
                  `<div>
                    <div style="font-size:13px;text-align:left;">
                      <span class="color-indicator" style="background-color:${point.series.color}"></span>
                      ${point.series.name}
                    </div>
                    <div style="font-size:13px;font-weight:bold;text-align:left;">${point.y?.toFixed(2)} m<sup>3</sup></div>
                  </div>`;
              // Litre value below m³
              if (typeof point.y === 'number') {
                const litres = point.y * 1000;
                tooltip += `<div style="font-size:11px;color:#888;text-align:left;margin-bottom:8px;">${litres.toLocaleString(undefined, {maximumFractionDigits:2})} L</div>`;
              }
              tooltip +=
                findCarbon(this.points, index) +
                '';
              // tooltip += 'Number of Equipments: ' + point.point.options.number_of_equipments + '<br/>';
            });
            return is_incomplete_flag
              ? (tooltip +=
                  '<div><span class="color-indicator" style="backgroundColor:' +
                  `${ColorIndicator('Incomplete')}` +
                  '" ></span>Incomplete period </div>')
              : tooltip;
            // return tooltip;
          }
        : function () {
            return getTotalEnergyUseBarTooltop({
              drillDownLevel: drillDownLevel,
              graphFilter: graphFilter,
              thisPoint: this.point,
              chartUnit: this.series.options.custom?.unit || chartUnit,
              chartSlugInfo: chartSlugInfo,
              yPoint: this.y,
              seriesName: this.series.name,
              isMultipleSeries: isMultipleSeries
            });
          },
      outside: true,
      positioner: function (labelWidth, labelHeight, point) {
        var x = Math.min(
          Math.max(point.plotX + this.chart.plotLeft - labelWidth / 2, this.chart.plotLeft),
          this.chart.plotWidth + this.chart.plotLeft - labelWidth
        );
        var y = point.plotY + this.chart.plotTop - labelHeight - 5;
        return { x: x, y: y };
      }
    }
  };

  return config;
}
export default totalEnergyUseChartDataConfig;
